import { ReactElement, useEffect, useState } from "react";

import { AuthContext } from "@/auth/AuthContext";

interface IAuthProviderProps {
	children: ReactElement<any> | ReactElement<any>[];
}

export function AuthProvider({ children }: IAuthProviderProps) {
	const contextValue = useContextChange();
	return (
		<AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
	);
}

const useContextChange = () => {
	const [isAuthflowCompleted, setIsAuthflowCompleted] = useState(false);
	const [isFetching, setIsFetching] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [account, setAccount] = useState<any>();

	const login = (
		postLoginRedirectUri: string,
		scopesToConsent: Array<string>,
	) => {
		let url = "/api/auth/login";

		const searchParams = new URLSearchParams({});

		if (postLoginRedirectUri) {
			searchParams.append(
				"postLoginRedirectUri",
				encodeURIComponent(postLoginRedirectUri),
			);
		}

		if (scopesToConsent) {
			searchParams.append("scopesToConsent", scopesToConsent.join(" "));
		}

		url = `${url}?${searchParams.toString()}`;
		window.location.replace(url);
	};

	useEffect(() => {
		const getAccount = async () => {
			setIsFetching(true);
			const response = await fetch("/api/auth/account");
			const data = await response.json();

			if (data.isAuthenticated) {
				setAccount(data.claims);
			}

			setIsAuthenticated(data.isAuthenticated);
			setIsFetching(false);

			setIsAuthflowCompleted(true);
		};

		getAccount();
	}, []);

	return {
		isAuthenticated,
		isFetching,
		isAuthflowCompleted,
		account,
		login,
	};
};
